/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-05 14:39:22
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-25 20:06:39
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\index.js
 * @Description: 付费延保
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */
import './index.less';
import { RegularBanner } from '../five-kwh-market/sections/five-kwh-banner/index';
import { PEWForm } from './snippets/form';

document.addEventListener('DOMContentLoaded', () => {
  // 编辑模式
  const isEditMode = window.Shopify && window.Shopify.designMode;
  if (!window.pageInfo.customerInfo.id && !isEditMode) {
    // 未登录跳转登录页
    location.href=`${window.pageInfo.account_url}/login?&return_url=${encodeURIComponent(location.href)}&cr=${window.pageInfo.cr}`;
  } else {
    // 已登录
    new RegularBanner(document.querySelector('.five-kwh-banner .swiper-container'))
    PEWForm(isEditMode);
  }
})